import _SessionSchedule from './model';
import create from './create';

export const SessionSchedule = _SessionSchedule;

SessionSchedule.create = create;

export default SessionSchedule;



// WEBPACK FOOTER //
// ./containers/Group/GroupSummary/SessionSchedule/index.js